import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import ReactSVG from 'react-svg';
import injectSheet from 'react-jss';
import { compose } from 'redux';
import { injectIntl, intlShape } from 'react-intl';
import Typography from '../Typography';
import { getTextColorsFromSection } from '../lib/colors';
import Image from '../Image';
import Section from '../Section';
import facebook from './facebook.svg';
import instagram from './instagram.svg';
import twitter from './twitter.svg';
import youtube from './youtube.svg';
import googleplus from './googleplus.svg';
import linkedin from './linkedin.svg';
import Copyright from './Copyright';

const icons = {
  facebook: facebook,
  instagram: instagram,
  twitter: twitter,
  youtube: youtube,
  googleplus: googleplus,
  linkedin: linkedin,
};

function FooterSection({ classes, event, intl, site, section }) {
  const { data, styles } = section;
  const socials = data.socials || [];
  const colors = getTextColorsFromSection(site, section);

  return (
    <Section site={site} section={section}>
      <div className={classes.grid}>
        <div
          className={classNames(classes.organizationWrapper, !data.socials && classes.noSocials)}
        >
          <Typography type="body2" style={{ ...colors.title, ...styles.title }} paragraph>
            {data.title}
          </Typography>
          {Boolean(data.image && data.image.url) && (
            <a href={data.url} target="_blank" rel="noopener noreferrer">
              <Image
                src={data.image.url}
                alt={intl.formatMessage({ id: 'organizationBrandAlt' })}
                className={classNames(
                  classes.organizationImage,
                  !data.socials && classes.organizationImageNoSocials,
                )}
              />
            </a>
          )}
          <Typography style={{ ...colors.text, ...styles.text }} className={classes.multiline}>
            {data.contact}
          </Typography>
        </div>
        {data.socials && (
          <div
            className={classNames(
              classes.followOnSocialMediaWrapper,
              !data.contact && classes.noOrganization,
            )}
          >
            <Typography
              type="body2"
              style={{ ...colors.title, ...styles.title }}
              className={classNames(
                classes.followText,
                !data.contact && classes.followTextNoOrganization,
              )}
              paragraph
            >
              {data.follow}
            </Typography>
            <div
              className={classNames(
                classes.socialMediaImagesWrapper,
                !data.contact && classes.socialMediaImagesWrapperNoOrganization,
              )}
            >
              {socials.map(
                (social, i) =>
                  icons[social.type] && (
                    <a
                      key={social.type}
                      href={social.url}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <ReactSVG
                        style={(styles.socials && styles.socials[i]) || colors.text}
                        className={classes.socialMediaImage}
                        alt={social.text}
                        path={icons[social.type]}
                      />
                    </a>
                  ),
              )}
            </div>
          </div>
        )}
      </div>
      <Copyright event={event} site={site} section={section} />
    </Section>
  );
}

FooterSection.propTypes = {
  classes: PropTypes.object.isRequired,
  event: PropTypes.object.isRequired,
  intl: intlShape.isRequired,
  site: PropTypes.object.isRequired,
  section: PropTypes.object.isRequired,
};

const stylesheet = theme => ({
  grid: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: [theme.spacing.xlarge, theme.spacing.large],
    [theme.breakpoints.down('sm')]: {
      display: 'flex',
      justifyContent: 'flex-start',
      flexDirection: 'column',
      padding: [theme.spacing.large, theme.spacing.medium],
    },
  },
  organizationWrapper: {
    maxWidth: '50%',
    [theme.breakpoints.down('sm')]: {
      maxWidth: '100%',
    },
  },
  organizationImage: {
    marginBottom: 2 * theme.spacing.unit,
    minWidth: 80,
    minHeight: 80,
    maxWidth: 160,
    maxHeight: 160,
  },
  followOnSocialMediaWrapper: {
    maxWidth: '50%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    [theme.breakpoints.down('sm')]: {
      maxWidth: '100%',
      marginTop: 4 * theme.spacing.unit,
      alignItems: 'flex-start',
    },
  },
  followText: {
    [theme.breakpoints.up('sm')]: {
      textAlign: 'right',
    },
  },
  socialMediaImagesWrapper: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'flex-end',
    [theme.breakpoints.down('sm')]: {
      justifyContent: 'flex-start',
    },
  },
  socialMediaImage: {
    width: 50,
    height: 50,
    marginLeft: 2 * theme.spacing.unit,
    [theme.breakpoints.down('sm')]: {
      marginRight: 2 * theme.spacing.unit,
      marginLeft: 0,
    },
  },
  multiline: {
    whiteSpace: 'pre-line',
  },
  noSocials: {
    minWidth: '100%',
    textAlign: 'center',
  },
  noOrganization: {
    margin: 'auto',
  },
  organizationImageNoSocials: {
    marginBottom: 2 * theme.spacing.unit,
    margin: 'auto',
  },
  followTextNoOrganization: {
    alignSelf: 'center',
  },
  socialMediaImagesWrapperNoOrganization: {
    justifyContent: 'center',
  },
});

export default compose(
  injectIntl,
  injectSheet(stylesheet),
)(FooterSection);



// WEBPACK FOOTER //
// ./src/site-render/src/FooterSection/FooterSection.js